import React from 'react'
import { CronEvent } from '../../domain/Event'

interface Props {
    data: CronEvent
}
class Cron extends React.Component<Props> {
    public render() {
        return (
            <div className="box event-box">
                <div className="box-body">
                    <div className="timeline-body">
                        {this.props.data.status === 'running' ? (
                            <p>This cronjob is still running. It will be marked as failure after {this.props.data.failureAfter} minutes.</p>
                        ) : (
                            <p>
                                This cronjob ran for {this.props.data.duration} and completed with status {`"${this.props.data.status}"`}.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default Cron
